import { CursorQuery, Paginated } from '../../common/pagination.js';
import { MarriageReviewView, MarriageVerificationDownload, ReviewMarriageInput, } from '../../marriage.js';
export const adminMarriageRoutes = {
    marriageReviews: {
        method: 'GET',
        path: '/admin/family/marriages',
        query: CursorQuery,
        response: Paginated(MarriageReviewView),
    },
    marriageVerification: {
        method: 'GET',
        path: '/admin/family/marriages/:marriageId/verification',
        response: MarriageVerificationDownload,
    },
    decideMarriage: {
        method: 'POST',
        path: '/admin/family/marriages/:marriageId/review',
        body: ReviewMarriageInput,
        response: MarriageReviewView,
    },
};
//# sourceMappingURL=routes.js.map